import {Button} from "../ui-components/button.tsx";
import {FC} from "react";


type DefaultBtnType = {
    title:string
    onClick?:() => void
}
export const DefaultBtn:FC<DefaultBtnType> = ({title, onClick}) => {
    return(
        <Button onClick={onClick} color={"dark/white"} className={"w-full !text-sm py-[10px] leading-[18px] !font-normal !text-white !rounded-md"}>
            {title}
        </Button>
    )
}